import { FEET, KILOMETERS, LENGTH, LengthUnit, METERS, NAUTICAL_MILES, STATUTE_MILES } from '../units';
import { BaseConverter } from './base-converter';


/**
 * Conversion factor for distance in meters to feet
 */
export const M_TO_FT = 3.28084;

/**
 * Conversion factor for distance in meters to kilometers
 */
export const M_TO_KM = 0.001;

/**
 * Conversion factor for distance in meters to nautical miles
 */
export const M_TO_NM = 0.000539957;

/**
 * Conversion factor for distance in meters to nautical miles
 */
export const M_TO_SM = 0.000621371;


/**
 * Length unit converter class
 */
export class LengthConverter extends BaseConverter<LengthUnit> {
  protected _baseUnit: LengthUnit = METERS;

  constructor() {
    super(LENGTH);
    this._conversionFactors.set(FEET, M_TO_FT);
    this._conversionFactors.set(KILOMETERS, M_TO_KM);
    this._conversionFactors.set(NAUTICAL_MILES, M_TO_NM);
    this._conversionFactors.set(STATUTE_MILES, M_TO_SM);
    this._check();
  }
}


/**
 * Length unit converter singleton
 */
export const LENGTH_CONVERTER: LengthConverter = new LengthConverter();
